export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  nameEs: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  initials: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  companyID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/department/department-form.js